export const statusTableApi = {
    data:[
        {

        },
        {

        },
        {

        },
        {

        },
        {

        },
    ]
}